import { useRef } from 'react';
import Stack from '@mui/material/Stack';
import { DetailForm } from './detail-form';
import BackNavigation from 'src/components/ui/headers/title-back';
import useForms from 'src/api/orders/vm-form';
import useToast from 'src/utils/toast-utils';
import PageSection from 'src/layouts/page-section';

const Page = ({ onNavigate, item }) => {
  const rootRef = useRef(null);
  const { insertItem, updateItem, removeItem } = useForms();
  const { toastSuccess, toastError } = useToast();

  // Add new item
  const apiCreate = async (values) => {
    await insertItem(
      values,
      (result) => {
        toastSuccess(`Đã thêm ${result}`, {action: 'back'});
      },
      (error) => {
        toastError(error);
      },
    );
  };

  // Update item
  const apiUpdate = async (values) => {
    await updateItem(
      values,
      (result) => {
        toastSuccess(`Đã sửa ${result}`, {action: 'back'});
      },
      (error) => {
        toastError(error);
      },
    );
  };

  // Update item
  const apiRemove = async (values) => {
    await removeItem(
      values,
      (result) => {
        toastSuccess(`Đã xóa ${result}`, {action: 'back'});
      },
      (error) => {
        toastError(error);
      },
    );
  };

  return (
    <PageSection title="Order" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={'Tổng quan'}
        />
        <Stack>
          <DetailForm
            item={item}
            apiCreate={apiCreate}
            apiUpdate={apiUpdate}
            apiRemove={apiRemove}
          />
        </Stack>
      </Stack>
    </PageSection>
  );
};

export default Page;
